module["exports"] = [
  "Абаџиевa",
  "Абовa",
  "Аврамовa",
  "Аврамовска",
  "Аврамчевa",
  "Ајановска",
  "Алексиевa",
  "Алексовa",
  "Алексовска",
  "Ангеловска",
  "Андовa",
  "Андоновa",
  "Андоновска",
  "Андреевска",
  "Антоновa",
  "Анчевска",
  "Апостолова",
  "Апостолска",
  "Арсовa",
  "Арсова",
  "Арсовска",
  "Атанасовa",
  "Атанасова",
  "Атанасовска",
  "Атковa",
  "Ацевa",
  "Ацевска",
  "Аџимитревска",
  "Бабамовска",
  "Бабунска",
  "Бавтировска",
  "Бајалска",
  "Бакевска",
  "Балабанова",
  "Басаровска",
  "Бачовска",
  "Беличанец",
  "Белковска",
  "Беловска",
  "Белогаска",
  "Белчевa",
  "Бендевска",
  "Билбиловска",
  "Билјановска",
  "Бислимовска",
  "Битовска",
  "Блажевска",
  "Близнаковa",
  "Богдановa",
  "Богдановска",
  "Богданска",
  "Богоевa",
  "Богоеска",
  "Божиковa",
  "Божинова",
  "Божиновска",
  "Бојановска",
  "Бојаџи",
  "Бојаџиевa",
  "Боцевска",
  "Бошевска",
  "Бошковa",
  "Бошковска",
  "Брезоска",
  "Бубуловска",
  "Бужаровска",
  "Бузевa",
  "Бујуклиевa",
  "Бунева",
  "Варсаковска",
  "Василевска",
  "Василеска",
  "Васковa",
  "Величковска",
  "Велјановa",
  "Велковa",
  "Висулчева",
  "Владимирска",
  "Владова",
  "Влаховa",
  "Влахчева",
  "Вражалска",
  "Гаврилска",
  "Гајдова",
  "Галевска",
  "Гапо",
  "Гаревска",
  "Геновa",
  "Георгиевa",
  "Георгиевска",
  "Герасимовска",
  "Гермовa",
  "Геровa",
  "Гечевска",
  "Гешоска",
  "Гиговa",
  "Гиевска",
  "Главаш",
  "Глигоровa",
  "Глигоровска",
  "Голабовска",
  "Грабул",
  "Грабулоска",
  "Гроздановa",
  "Грошевa",
  "Грујовска",
  "Групче",
  "Гугувчевска",
  "Гучева",
  "Давидовска",
  "Давковa",
  "Давчевa",
  "Давчевска",
  "Дамеска",
  "Дамовска",
  "Дворчанец",
  "Дејановa",
  "Демниева",
  "Деспотовска",
  "Дилевa",
  "Димитриева",
  "Димитровa",
  "Димковска",
  "Димовa",
  "Димовска",
  "Диневa",
  "Диневска",
  "Добревска",
  "Додевска",
  "Дојчиновa",
  "Доневска",
  "Дракул",
  "Дренковa",
  "Дрнковa",
  "Дуганова",
  "Дуковска",
  "Ѓаконовска",
  "Ѓелевa",
  "Ѓорѓевска",
  "Ѓорчевa",
  "Ѓузелевa",
  "Ѓурлуковa",
  "Ѓурчиновa",
  "Евремовa",
  "Едиповска",
  "Ежовa",
  "Ефтимова",
  "Жековa",
  "Железаровa",
  "Жерновска",
  "Забазноска",
  "Зафировска",
  "Здравевa",
  "Здравковска",
  "Зографска",
  "Ивановa",
  "Ивановска",
  "Иваноска",
  "Игновска",
  "Игњатовска",
  "Икономовa",
  "Илиевa",
  "Илиевска",
  "Иљоска",
  "Исаковска",
  "Ицева",
  "Јакимовска",
  "Јаконовa",
  "Јаневска",
  "Јанчевска",
  "Јачевa",
  "Јовановa",
  "Јовановска",
  "Јовчевска",
  "Јордановa",
  "Јордановска",
  "Јосифовска",
  "Јосифоска",
  "Јурукова",
  "Јурукоска",
  "Калајџиска",
  "Калчевска",
  "Камберска",
  "Кантарџиевa",
  "Караѓозовa",
  "Карадак",
  "Караман",
  "Каранфиловска",
  "Караџа",
  "Каревa",
  "Каровa",
  "Каровска",
  "Картовa",
  "Катарџиевa",
  "Кепеска",
  "Керамитчиевa",
  "Керамичиевa",
  "Кирјазовска",
  "Киселиновa",
  "Китаноска",
  "Кичевска",
  "Кљусевa",
  "Колишевска",
  "Колозовa",
  "Кондова",
  "Кондовска",
  "Конеска",
  "Константиновa",
  "Константиновска",
  "Кордаловa",
  "Коробар",
  "Корубин",
  "Костадинова",
  "Костовска",
  "Котевска",
  "Котеска",
  "Коцаре",
  "Коцо",
  "Кочовска",
  "Коџоман",
  "Крле",
  "Крстева",
  "Крстевска",
  "Крстеска",
  "Крцковска",
  "Кузмановска",
  "Кулишевa",
  "Куновска",
  "Куноска",
  "Кутурец",
  "Кушевска",
  "Ладинска",
  "Лазаревска",
  "Лазаровa",
  "Лазарова",
  "Лазеска",
  "Лазовска",
  "Лакинска",
  "Лактинска",
  "Лапе",
  "Лахтова",
  "Левенска",
  "Лековска",
  "Леовa",
  "Лечевска",
  "Липова",
  "Личеноска",
  "Лозановска",
  "Луловска",
  "Љуткова",
  "Мазевa",
  "Мајсторовa",
  "Македонска",
  "Малевска",
  "Малеска",
  "Маловска",
  "Манаковска",
  "Манговa",
  "Манговска",
  "Маневa",
  "Манева",
  "Маневска",
  "Манивиловa",
  "Манчевa",
  "Манчевска",
  "Мариновa",
  "Марковска",
  "Мартиновска",
  "Мартиноска",
  "Масин",
  "Матевска",
  "Матковска",
  "Матовска",
  "Маџировa",
  "Миладиновa",
  "Милосавлева",
  "Милошевска",
  "Милчин",
  "Миљовска",
  "Минчевa",
  "Миовска",
  "Миронска",
  "Мисиркова",
  "Митевска",
  "Митревска",
  "Митриќеска",
  "Михајловa",
  "Михајловска",
  "Мицевa",
  "Мицевска",
  "Мицковска",
  "Мицовa",
  "Мишковска",
  "Младеновa",
  "Младеновска",
  "Мојсовска",
  "Мокровa",
  "Момировска",
  "Мошин",
  "Мукаетовa",
  "Муратовска",
  "Мусалевска",
  "Мустачки",
  "Најденовa",
  "Најдовска",
  "Најческа",
  "Наковa",
  "Наневска",
  "Настевa",
  "Наумовa",
  "Наумовска",
  "Наумческа",
  "Начевa",
  "Неделковска",
  "Нестор",
  "Несторовска",
  "Нетковa",
  "Нешковска",
  "Николеска",
  "Николовa",
  "Николовска",
  "Никушевa",
  "Ниновa",
  "Оровчанец",
  "Ортаковa",
  "Османли",
  "Павловска",
  "Павлоска",
  "Пајтонџиевa",
  "Паковска",
  "Паликрушева",
  "Панговска",
  "Пандеска",
  "Пандиловa",
  "Пандовска",
  "Панковa",
  "Пановa",
  "Пановска",
  "Панчевска",
  "Папрадишки",
  "Пејовa",
  "Пендовска",
  "Пенушлиска",
  "Пепељуговска",
  "Перинска",
  "Перчинковска",
  "Петковска",
  "Петровa",
  "Петровска",
  "Петрушевa",
  "Петрушевска",
  "Пиперковска",
  "Планинска",
  "Подгорец",
  "Полежиноска",
  "Полјанска",
  "Поповa",
  "Поповска",
  "Попоска",
  "Преспанска",
  "Прилепчанска",
  "Прличко",
  "Псалтировa",
  "Пуцкова",
  "Равановска",
  "Радическа",
  "Раковска",
  "Рацин",
  "Реџепова",
  "Ризовa",
  "Ристовa",
  "Ристовска",
  "Ристоска",
  "Руменова",
  "Русјаковa",
  "Русомановa",
  "Салџиева",
  "Саневa",
  "Сариевска",
  "Светиевa",
  "Серафимовa",
  "Серафимовска",
  "Сидовска",
  "Силјановска",
  "Симовa",
  "Симовска",
  "Симоновска",
  "Скаловска",
  "Славенска",
  "Славеска",
  "Сланева",
  "Смаќоска",
  "Смилевска",
  "Смокварска",
  "Соколовa",
  "Солевa",
  "Солунска",
  "Софрониевска",
  "Спасеновска",
  "Спасовa",
  "Спасовска",
  "Спировa",
  "Спировска",
  "Ставревa",
  "Ставреска",
  "Стаматоска",
  "Станковa",
  "Станковска",
  "Старделовa",
  "Стевановa",
  "Стевковска",
  "Стефановa",
  "Стефановска",
  "Стојановa",
  "Стојановска",
  "Стојаноска",
  "Стојковa",
  "Стојковска",
  "Стојменска",
  "Стојчевa",
  "Такева",
  "Таковска",
  "Талевска",
  "Талеска",
  "Темелкоска",
  "Теодосиевска",
  "Терзиевa",
  "Тодоровa",
  "Тодоровска",
  "Тозија",
  "Толевска",
  "Томовска",
  "Тофоска",
  "Точко",
  "Тошевa",
  "Тошевска",
  "Трајковска",
  "Тренеска",
  "Тренчевска",
  "Трифуновска",
  "Тројачанец",
  "Трпеновска",
  "Тушевска",
  "Ќамиловa",
  "Ќорнаковa",
  "Ќортошевa",
  "Ќурчиевa",
  "Угриновска",
  "Узуновa",
  "Узуновска",
  "Урдин",
  "Филиповска",
  "Фирфовa",
  "Фотева",
  "Хаџимановa",
  "Хаџиниколовa",
  "Христова",
  "Христовска",
  "Цаневa",
  "Цветановска",
  "Цековa",
  "Цековска",
  "Ценевa",
  "Црвенковска",
  "Црвеновa",
  "Чакар",
  "Чакмаковa",
  "Чаловска",
  "Чапаровска",
  "Чаушевa",
  "Чашуле",
  "Чевревска",
  "Чејковска",
  "Чемерска",
  "Чемковa",
  "Чипан",
  "Чокревска",
  "Чундева",
  "Чупона",
  "Чучковa",
  "Чушкаровa",
  "Џамбаз",
  "Џамбазова",
  "Џаџевa",
  "Џековa",
  "Џинлеска",
  "Џорлевa",
  "Џувалековска",
  "Џуновa",
  "Шаревска",
  "Шијак",
  "Шијаковa",
  "Шијаковска",
  "Шириловa",
  "Шишковa",
  "Шоповa",
  "Шоптрајановa",
  "Штерјоска",
  "Шулинчевска"
];
